import(/* webpackMode: "eager" */ "/usr/server/app/apps/pcc-nextjs-bff/app/[lang]/[esite]/legal/legal-notices/legal-notices.module.scss");
;
import(/* webpackMode: "eager" */ "/usr/server/app/apps/pcc-nextjs-bff/components/blocks-components.tsx");
;
import(/* webpackMode: "eager" */ "/usr/server/app/apps/pcc-nextjs-bff/components/espot/espot-content.tsx");
